module.exports = __webpack_public_path__ + "static/media/L-5.c2442537.svg";